<template>
  <div class="container-body">
    <div id="container" class="container"></div>
    <LFComponents v-model="nodeObj" @success="getData"/>
    <SqlCmd ref="SqlCmd"/>
    <SelelctTables v-model="select_table" @success="getTableData"/>
    <div><el-button @click="getData">获取数据</el-button></div>
  </div>
</template>

<script>
import { Graph, Cell, Shape } from '@antv/x6'
import er_data from "./data.json"
import t_data from "./t.json"
import table_data from "./table.json"
import LFComponents from "./components/LFComponents";
import DataHelp from "./common/DataHelp";
import SqlCmd from "./components/SqlCmd";
import Http from "./common/Http";
import SelelctTables from "./components/SelelctTables";

const LINE_HEIGHT = 24
const NODE_WIDTH = 150
export default {
  name: "ER",
  components: {SelelctTables, SqlCmd, LFComponents},
  data(){
    return{
      graph:null,
      nodeObj:{},
      graphObj:{},
      select_table:[]
    }
  },
  mounted() {
    this.initRegister();
    this.initGraph();
    // this.getTableData();
  },
  activated() {

  },
  methods:{
    getTableData(){
      var that=this;
      Http.get("flow/DataHelp/getTable",{tables:that.select_table.join(',')},ret=>{
        if(ret.code){
          let data_tb=DataHelp.getData(ret.data);
          that.graph.fromJSON(data_tb);
        }
      })
    },
    getData(){
      this.$refs.SqlCmd.initData(this.graph.toJSON())
    },
    initRegister(){
      Graph.registerPortLayout(
        'erPortPosition',
        (portsPositionArgs) => {
          return portsPositionArgs.map((_, index) => {
            return {
              position: {
                x: 0,
                y: (index + 1) * LINE_HEIGHT,
              },
              angle: 0,
            }
          })
        },
        true,
      )

      Graph.registerNode(
        'er-rect',
        {
          inherit: 'rect',
          markup: [
            {
              tagName: 'rect',
              selector: 'body',
            },
            {
              tagName: 'text',
              selector: 'label',
            },
          ],
          attrs: {
            rect: {
              strokeWidth: 1,
              stroke: '#5F95FF',
              fill: '#5F95FF',
            },
            label: {
              fontWeight: 'bold',
              fill: '#ffffff',
              fontSize: 12,
            },
          },
          ports: {
            groups: {
              list: {
                markup: [
                  {
                    tagName: 'rect',
                    selector: 'portBody',
                  },
                  {
                    tagName: 'text',
                    selector: 'portNameLabel',
                  },
                  {
                    tagName: 'text',
                    selector: 'portTypeLabel',
                  },
                ],
                attrs: {
                  portBody: {
                    width: NODE_WIDTH,
                    height: LINE_HEIGHT,
                    strokeWidth: 1,
                    stroke: '#5F95FF',
                    fill: '#EFF4FF',
                    magnet: true,
                  },
                  portNameLabel: {
                    ref: 'portBody',
                    refX: 6,
                    refY: 6,
                    fontSize: 10,
                  },
                  portTypeLabel: {
                    ref: 'portBody',
                    refX: 95,
                    refY: 6,
                    fontSize: 10,
                  },
                },
                position: 'erPortPosition',
              },
            },
          },
        },
        true,
      )
    },
    initGraph(){
      var that=this;
      that.graph = new Graph({
        container: document.getElementById('container'),
        width:window.outerWidth,
        height:window.outerHeight,
        panning: true,
        mousewheel: true,
        // autoResize: true,
        connecting: {
          router: {
            name: 'er',
            args: {
              offset: 25,
              direction: 'H',
            },
          },
          createEdge() {
            return new Shape.Edge({
              attrs: {
                line: {
                  stroke: '#A2B1C3',
                  strokeWidth: 2,
                },
              },
            })
          },
        },
        background: {
          color: "#F2F7FA",
        },
        grid: {
          visible: true,
          type: "doubleMesh",
          args: [
            {
              color: "#eee", // 主网格线颜色
              thickness: 1, // 主网格线宽度
            },
            {
              color: "#ddd", // 次网格线颜色
              thickness: 1, // 次网格线宽度
              factor: 4, // 主次网格线间隔
            },
          ],
        },
      });
      that.graph.translate(- window.outerWidth, - window.outerHeight); // 在 x、y 方向上平移画布

      that.graph.zoomToFit({ padding: 10, maxScale: 1 })
      that.graph.on("edge:mouseenter", ({ cell }) => {
        that.nodeObj=cell;
        cell.addTools([
          { name: "vertices" },
          {
            name: "button-remove",
            args: { distance: 20 },
          },
        ]);
      });
      that.graph.on("edge:mouseleave", ({ cell }) => {
        if (cell.hasTool("button-remove")) {
          cell.removeTool("button-remove");
        }
      });
      // 双击进入编辑模式
      that.graph.on("node:dblclick", ({ node, e }) => {
        node.addTools({
          name: "node-editor",
          args: {
            event: e,
          },
        });
      });
      // 双击进入编辑模式
      that.graph.on("node:mousedown", ({ node, e }) => {
        that.nodeObj=node;
      });
      that.graph.on("node:mouseup", ({ node, e }) => {
        that.nodeObj=node;
      });
      that.graph.on("node:mouseenter", ({ node }) => {
        node.addTools([
          {
            name: "button-remove",
            args: { x: 10, y: 10 },
          },
        ]);
      });

      that.graph.on("node:mouseleave", ({ node }) => {
        if (node.hasTool("button-remove")) {
          node.removeTool("button-remove");
        }
      });
      that.graph.on("edge:removed", ({ edge }) => {
        that.getData()
      });
      that.graph.on("node:removed", ({ node }) => {
        that.getData()
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.container-body{
  width: calc(100vw - 140px);
  height: calc(100vh - 150px);
  position: relative;
  .container{
    width: calc(100vw - 140px);
    height: calc(100vh - 150px);
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Admin/Database/ER.vue